import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=2835757b&scoped=true&"
import script from "./DocumentRow.vue?vue&type=script&lang=js&"
export * from "./DocumentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835757b",
  null
  
)

export default component.exports